import utils from '../lib/utils';
import '../../vendor/jquery.popupoverlay';
import '../../vendor/jquery-select.js';

let list = {};

export default function() {
    $(function() {
        let $partAlertModal = $('#partAlertModal');
        let popupOptions = {
            onclose: function() {
                $partAlertModal.trigger('modal-closes');
            }
        };
        utils.createModal($partAlertModal, null, popupOptions);
        $partAlertModal.removeClass('hide');

        let step = 1;

        $partAlertModal.find('.j-close-part-alerts').on('click', function() {
            $partAlertModal.popup('hide');
        });

        $(document).on('keydown', '.quantity-input', function(e) {
            if (e.key === 'e' || e.key === '.') {
                e.preventDefault();
            }
        });

        $(document).on('keydown', '.price-input', function(e) {
            if (e.key === 'e') {
                e.preventDefault();
            }
        });

        $partAlertModal.find('.add-alert').on('click', function() {
            let $this = $(this);
            if ($this.closest('.j-alert-settings').hasClass('is-disabled')) {
                return false;
            }

            let $inventoryList = $(this).closest('.alert-section').find('.alert-list');
            let $li = $inventoryList.find('li:first');
            let $clone = $li.clone();

            if ($clone.find('.alert-select').length) {
                let $originalAlertSelect = $li.find('.alert-select');
                let $options = $originalAlertSelect.find('option');
                $originalAlertSelect.attr('data-readonly', true);
                $originalAlertSelect.change();
        
                let $cloneAlertSelect = $clone.find('.alert-select');
                let cloneAlertVal = $originalAlertSelect.val() == $($options[0]).attr('value') ? $($options[1]).attr('value') : $($options[0]).attr('value');
                $cloneAlertSelect.val(cloneAlertVal);
                $cloneAlertSelect.attr('data-readonly', true);
                $cloneAlertSelect.attr('name', $originalAlertSelect.attr('name') + '2');
                $cloneAlertSelect.selectOverlap();
            }

            if ($clone.find('.quantity-input').length) {
                let $priceInput = $clone.find('.price-input');
                $priceInput.attr('name', $li.find('.price-input').attr('name') + '2').val('');
                let $quantityInput = $clone.find('.quantity-input');
                $quantityInput.attr('name', $li.find('.quantity-input').attr('name') + '2').val('');
                $quantityInput.on('keydown', onlyAcceptNumbersHandler);
            }

            if ($clone.find('.alert-expire-select').length) {
                let $cloneAlertExpireSelect = $clone.find('.alert-expire-select');
                $cloneAlertExpireSelect.attr('name', $li.find('.alert-expire-select').attr('name') + '2');
                $cloneAlertExpireSelect.selectOverlap();
            }

            if ($clone.find('.expired-notice').length) {
                $clone.find('.expired-notice').addClass('hide');
            }

            $clone.append('<button type="button" class="other-button is-small remove-alert">Remove</button>');

            $(this).addClass('hide');
            $inventoryList.append($clone);
            $clone.find('.quantity-input').trigger('focus');
        });

        $partAlertModal.on('click', '.remove-alert', function() {
            let $this = $(this);
            if ($this.closest('.j-alert-settings').hasClass('is-disabled')) {
                return false;
            }

            let $alertSection = $(this).closest('.alert-section');
            let $li = $alertSection.find('.alert-list li:first');
            let $inventoryAlert = $li.find('.alert-select');
            $inventoryAlert.attr('data-readonly', false);
            $inventoryAlert.trigger('change');
            $alertSection.find('.add-alert').removeClass('hide');
            $li.find('.quantity-input').trigger('focus');
            $this.parent('li').remove();
        });

        $partAlertModal.find('.j-alert-checkbox').on('change', function() {
            let $this = $(this);
            let $settings = $this.siblings('.j-alert-settings');
            let $selects = $settings.find('select');
            if ($this.is(':checked')) {
                let alternatesEnabled = $settings.find('.alternative-toggle').is(':checked');
                if (alternatesEnabled) {
                    $settings.find('input').prop('disabled', false);
                    $settings.find('.select-all-alt-btn').prop('disabled', false);
                    $settings.find('.part-alert-alternates .is-disabled').removeClass('is-disabled');
                } else {
                    $settings.find('input:not(.alternative-checkbox)').prop('disabled', false);
                }

                $selects.attr('data-disabled', false);
                $selects.trigger('change');

                $settings.removeClass('is-disabled');
            } else {
                $settings.find('input').prop('disabled', true);
                $settings.find('.select-all-alt-btn').addClass('is-disabled').prop('disabled', true);

                $selects.attr('data-disabled', true);
                $selects.trigger('change');

                $settings.find('.existing-alert-warning, .has-existing-alert').addClass('is-disabled');

                $settings.addClass('is-disabled');
            }

            if (!$partAlertModal.find('.j-alert-checkbox:checked').length) {
                $partAlertModal.find('.j-alerts-next').prop('disabled', true).addClass('disabled');
                $partAlertModal.find('.j-confirm-btn').addClass('disabled');
            } else {
                $partAlertModal.find('.j-alerts-next').prop('disabled', false).removeClass('disabled');
                $partAlertModal.find('.j-confirm-btn').removeClass('disabled');
            }
        });

        $partAlertModal.find('.quantity-input').on('keydown', onlyAcceptNumbersHandler);

        function onlyAcceptNumbersHandler(event) {
            if (event.key.length === 1 && !/\d/.test(event.key)) {
                return event.preventDefault();
            }
        }

        function validateStepOne() {
            let $tab = $('.j-part-alert-tab');
            $tab.find('.error').removeClass('error');
            $('.j-part-alert-form-error').addClass('hide');
            let error = false;

            $tab.find('input:not([type=hidden], :disabled, .custom-option-list-search)').each(function() {
                if ($(this).val() === '') {
                    $(this).addClass('error');
                    error = true;
                }
            });

            if (error) {
                $('.j-part-alert-form-error').text(utils.translate('please.input.missing.fields'));
                $('.j-part-alert-form-error').removeClass('hide');
                return false;
            }

            $tab.find('input[type=number]:not(:disabled)').each(function() {
                let value = $(this).val();
                if (parseFloat(value) > parseFloat($(this).attr('max')) || parseFloat(value) <= parseFloat($(this).attr('min')) - 1) {
                    $(this).addClass('error');
                    error = true;
                }
            });

            if (error) {
                $('.j-part-alert-form-error').text(utils.translate('part.alert.number.restrictions'));
                $('.j-part-alert-form-error').removeClass('hide');
                return false;
            }

            let quantityErr = false;
            let currencyErr = false;
            $tab.find('input[type=number]:not(:disabled)').each(function() {
                let decimals = $(this).val().split('.').length > 1 ? $(this).val().split('.')[1].length : 0;
                let steps = $(this).attr('step').split('.').length > 1 ? $(this).attr('step').split('.')[1].length : 0;
                if (decimals > steps) {
                    $(this).addClass('error');
                    if (steps === 0) {
                        quantityErr = true;
                    } else {
                        currencyErr = true;
                    }
                }
            });

            if (quantityErr || currencyErr) {
                let msg = '';
                if (quantityErr) {
                    msg += utils.translate('part.alert.whole.number.err');
                }
                if (currencyErr) {
                    if (msg.length) {
                        msg += ' ';
                    }
                    msg += utils.translate('part.alert.decimal.err');
                }
                $('.j-part-alert-form-error').text(msg);
                $('.j-part-alert-form-error').removeClass('hide');
                return false;
            }

            $tab.find('input[type=number]:not(:disabled)').each(function() {
                if ($(this).prop('step') == 1) {
                    if (parseInt($(this).val()) != $(this).val()) {
                        $(this).addClass('error');
                        error = true;
                    }
                }
            });

            if (error) {
                $('.j-part-alert-form-error').text(utils.translate('part.alert.whole.number.err'));
                $('.j-part-alert-form-error').removeClass('hide');
                return false;
            }

            if (!$('.j-alert-checkbox:checked').length) {
                $('.j-part-alert-form-error').text(utils.translate('part.alert.at.least.1.alert.err'));
                $('.j-part-alert-form-error').removeClass('hide');
                $('.j-alert-checkbox').addClass('error');
                return false;
            } else {
                $('.j-alert-checkbox').removeClass('error');
            }

            return true;
        }

        $('.j-alerts-next').on('click', function() {
            if (validateStepOne()) {
                $('.j-part-alert-tab').addClass('hide');
                $partAlertModal.addClass('select-preferred-modal');
                $('.j-preferred-distributor-tab').removeClass('hide');
                step += 1;
            }
        });

        function hidePreferredDistributors() {
            $('.j-preferred-distributor-tab').addClass('hide');
            $partAlertModal.removeClass('select-preferred-modal');
            $('.j-part-alert-tab').removeClass('hide');
            step -= 1;
        }

        $('.j-close-preferred-distributors').on('click', function() {
            hidePreferredDistributors();
        });

        function hideRegistration() {
            $('.j-registration-tab').addClass('hide');
            $partAlertModal.addClass('select-preferred-modal');
            $('.j-preferred-distributor-tab').removeClass('hide');
            step -= 1;
        }

        $('.j-close-registration').on('click', function() {
            hideRegistration();
        });

        $('.sign-in-link .hyperlink').on('click', function() {
            $partAlertModal.find('.j-registration').addClass('hide');
            $partAlertModal.find('.j-signin').removeClass('hide');
            $partAlertModal.find('.j-submit-btn').val(utils.translate('sign.in.and.set.alerts'));
            $('.j-part-alert-form').attr('action', '/account/alertSignin');
        });

        function clickRegisterLink() {
            $partAlertModal.find('.j-signin').addClass('hide');
            $partAlertModal.find('.j-registration').removeClass('hide');
            $partAlertModal.find('.j-submit-btn').val(utils.translate('register.and.set.alerts'));
            $('.j-part-alert-form').attr('action', '/account/alertRegistration');
        }

        $('.register-link .hyperlink').on('click', function() {
            clickRegisterLink();
        });

        let closeModalTimeout, refreshPageTimeout;
        $('.j-part-alert-form').on('keydown', 'input:not(.custom-option-list-search)', function(e) {
            if (e.which == 13) { // enter
                e.preventDefault();
                let $this = $(this);
                $this.closest('.j-modal-tab').find('.j-confirm-btn').click();
            }
        });

        $('.j-preferred-distributor-next').on('click', function() {
            $('.j-distributor-error').addClass('hide');
            if (checkSelected() === 0) {
                $('.j-distributor-error').text(utils.translate('please.choose.at.least.one.distributor')).removeClass('hide');
                return false;
            }

            $('.j-preferred-distributor-tab').addClass('hide');
            $partAlertModal.removeClass('select-preferred-modal');
            $('.j-registration-tab').removeClass('hide');
            $('#recaptchaScript').remove();
            if (typeof importRecaptcha === 'function') {
                importRecaptcha();
            }
            step += 1;
        });

        $('.j-part-alert-form').on('submit', function(e) {
            e.preventDefault();
            let $this = $(this);
            $('.j-distributor-error').addClass('hide');
            $('.j-registration-error').addClass('hide');

            if (step === 3) {
                let $tab = $partAlertModal.find('.j-registration-tab');
                let error = false;

                $('.j-registration-error').addClass('hide');
                $tab.find('.error').removeClass('error');

                $tab.find('input:not([type=hidden], :disabled, #confirm_password)').each(function() {
                    if ($(this).val() === '') {
                        $(this).addClass('error');
                        error = true;
                    }
                });

                if (error) {
                    $('.j-registration-error').text('Please input missing fields.');
                    $('.j-registration-error').removeClass('hide');
                    return false;
                }

                if ($('.j-part-alert-form').attr('action') === '/account/alertRegistration') {
                    let regex = new RegExp(/^((?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)|(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[^a-zA-Z0-9])|(?=.*?[A-Z])(?=.*?\d)(?=.*?[^a-zA-Z0-9])|(?=.*?[a-z])(?=.*?\d)(?=.*?[^a-zA-Z0-9])).{8,}$/);
                    if (!regex.test($('.password-field').val())) {
                        $('.password-field').addClass('error');
                        $('.j-registration-error').text('Password must be at least 8 characters long and contain at least 3 three of the following character types: lower case character (a-z), upper case characters (A-Z), numbers (0-9), special characters (e.g.: !#$%^&*).');
                        $('.j-registration-error').removeClass('hide');
                        return false;
                    }
                    if (!$('.j-confirm-privacy').is(':checked')) {
                        $('.j-registration-error').text('Please agree to our privacy policy and terms of service.').removeClass('hide');
                        return false;
                    }
                }
            } else if (step === 2) {
                if (checkSelected() === 0) {
                    $('.j-distributor-error').text(utils.translate('please.choose.at.least.one.distributor')).removeClass('hide');
                    return false;
                }
            } else {
                if (!validateStepOne()) {
                    return false;
                }
            }

            $partAlertModal.find('.loading').show();
            $.ajax({
                url: $this.attr('action'),
                type: $this.attr('method'),
                data: $this.serialize(),
                timeout: 15000,
                success: function(data) {
                    $('.j-registration-tab').addClass('hide');
                    $('.j-preferred-distributor-tab').addClass('hide');
                    $('.j-part-alert-tab').addClass('hide');
                    $partAlertModal.removeClass('select-preferred-modal');
                    if (!data.success) {
                        $('.j-error-tab').removeClass('hide');
                    } else {
                        $('.j-success-tab').removeClass('hide');
                    }
                    if ($('.j-registration-tab').length) {
                        location.reload();
                    } else {
                        closeModalTimeout = setTimeout(function() {
                            $partAlertModal.popup('hide');
                        }, 2000);
                    }
                    let $alertBtn = $('.j-alert');
                    if ($partAlertModal.find('.manufacturer-section').hasClass('hide') && $alertBtn.length && !$alertBtn.hasClass('edit-alert')) {
                        $alertBtn.find('.alert-text').text('Edit Alert');
                        $alertBtn.addClass('edit-alert');
                    }
                    let item = data.data;
                    if ($('.alert-page-table').length) {
                        let $row = $('#alert-' + item.id);
                        let oldData = JSON.parse(decodeURIComponent($row.attr('data-alert')));
                        $row.attr('data-alert', encodeURIComponent(JSON.stringify(item)));
                        let { inventoryText, inventoryDate, pricingText, pricingDate, hasExpired, pricingExpires } = displayAlertData($row);

                        let $alertStats = $('.j-alerts-stats');
                        let inventoryCount = parseInt($alertStats.attr('data-inventory-count'));
                        let pricingCount = parseInt($alertStats.attr('data-pricing-count'));

                        let inventoryChange = inventoryText ? 1 : 0;
                        let pricingChange = pricingText ? 1 : 0;
                        for (let old of oldData.settings) {
                            if (old.type === 'inventory') inventoryChange = 1;
                            if (old.type === 'pricing') pricingChange = 1;
                        }

                        inventoryCount += (inventoryText ? 1 : 0) - inventoryChange;
                        pricingCount += (pricingText  ? 1 : 0) - pricingChange;

                        if (data.alternatives) {
                            let $template = $('.alert-page-table .template-row');
                            let partsWithAlerts = parseInt($('.j-parts-with-alerts .alert-value').text());
                            for (let alternative of data.alternatives) {
                                let info = alternative[0];
                                let hasInventory = 0;
                                let hasPricing = 0;
                                for (let setting of info.settings) {
                                    if (setting.type === 'inventory') hasInventory = 1;
                                    if (setting.type === 'pricing') hasPricing = 1;
                                }
                                if (alternative[1] == 'insert') {
                                    let $clone = $template.clone();
                                    $clone.attr('id', 'alert-' + info.id).attr('data-alert', encodeURIComponent(JSON.stringify(info)));
                                    $clone.find('.j-data-part-number').attr('data-part-number', info.part);
                                    $clone.find('.j-data-part-number a').attr('href', '/detail/' + encodeURIComponent(info.part) + '/' + encodeURIComponent(utils.convertWhitespaceFormat(info.manufacturer))).text(info.part);
                                    $clone.find('.j-data-part-number .manufacturer-text').text(info.manufacturer);
                                    if (hasInventory) {
                                        $clone.find('.j-data-settings').append('<div class="text">' + inventoryText + '</div>');
                                    }
                                    if (hasPricing) {
                                        $clone.find('.j-data-settings').append('<div class="text">' + pricingText + '</div><div class="expired-text' + (hasExpired ? ' gray' : '') + '">' + pricingExpires + '</div>');
                                    }
                                    $clone.find('.j-data-settings').append('<div class="alternative-text gray">Alternate alert for ' + item.part + '</div>');
                                    $clone.find('.j-data-int-created').attr('data-int-created', Math.floor(new Date(info.created).getTime() / 1000)).text(utils.formatDatetime(new Date(info.created)));
                                    $clone.insertBefore('.alert-page-table .template-row');
                                    $clone.removeClass('hide');
                                    partsWithAlerts++;
                                    inventoryCount += hasInventory;
                                    pricingCount += hasPricing;
                                } else {
                                    let $altRow = $('#alert-' + info.id);
                                    oldData = JSON.parse(decodeURIComponent($altRow.attr('data-alert')));
                                    $altRow.attr('data-alert', encodeURIComponent(JSON.stringify(info)));
                                    $altRow.find('.j-data-settings').empty();
                                    if (hasInventory) {
                                        $altRow.find('.j-data-settings').append('<div class="text">' + inventoryText + '</div>');
                                    }
                                    if (hasPricing) {
                                        $altRow.find('.j-data-settings').append('<div class="text">' + pricingText + '</div><div class="expired-text' + (hasExpired ? ' gray' : '') + '">' + pricingExpires + '</div>');
                                    }
                                    inventoryDate = pricingDate = null;
                                    for (let setting of info.settings) {
                                        if (setting.type === 'inventory') {
                                            inventoryDate = setting.last_sent && (!inventoryDate || inventoryDate < new Date(setting.last_sent * 1000)) ? new Date(setting.last_sent * 1000) : inventoryDate;
                                        } else if (setting.type === 'pricing') {
                                            pricingDate = setting.last_sent && (!pricingDate || pricingDate < new Date(setting.last_sent * 1000)) ? new Date(setting.last_sent * 1000) : pricingDate;
                                        }
                                    }
                                    if (inventoryDate) {
                                        $row.find('.j-data-int-sent').append('<div ' + (hasPricing ? 'class="inventory-date"' : '') + '>' + utils.formatDatetime(inventoryDate) + '</div>');
                                    }
                                    if (pricingDate) {
                                        $row.find('.j-data-int-sent').append('<div ' + (hasInventory ? 'class="pricing-date"' : '') + '>' + utils.formatDatetime(pricingDate) + '</div>');
                                    }
                                    $altRow.find('.j-data-settings').append('<div class="alternative-text gray">Alternate alert for ' + item.part + '</div>');

                                    for (let oldSetting of oldData.settings) {
                                        if (oldSetting.type === 'inventory') hasInventory -= 1;
                                        if (oldSetting.type === 'pricing') hasPricing -= 1;
                                    }
                                    inventoryCount += hasInventory;
                                    pricingCount += hasPricing;
                                }
                            }
                            $('.j-parts-with-alerts .alert-value').text(partsWithAlerts);
                        }

                        $alertStats.attr('data-inventory-count', inventoryCount);
                        $alertStats.attr('data-pricing-count', pricingCount);

                        $(document).trigger('generate-alert-graphs');
                        
                    } else if ($('.detail-landing-table').length) {
                        let $row = $('.detail-landing-table tr[data-manufacturer="' + item.manufacturer.toUpperCase() + '"]');
                        $row.attr('data-alert', encodeURIComponent(JSON.stringify(item)));
                        $row.find('.alert-bell-btn').removeClass('fa-regular').addClass('fa-solid');
                    } else if ($('.my-parts-table').length) {
                        let $alert = $('.my-parts-table .alert-btn[data-part-manufacturer="' + item.part.toUpperCase() + '|' + item.manufacturer.toUpperCase() + '"]');
                        let addedNewAlert = $alert.hasClass('fa-regular');
                        let rowIsArchived = $alert.parents('tr').find('.archive-btn').hasClass('fa-solid');
                        $alert.attr('data-alert', encodeURIComponent(JSON.stringify(item)));
                        $alert.removeClass('fa-regular').addClass('fa-solid');
                        if (addedNewAlert) {
                            $(document).trigger(rowIsArchived ? 'added-new-archived-alert' : 'added-new-alert');
                        }
                    } else {
                        $('.j-preferred-distributor-tab').find('input[type=checkbox]').each(function() {
                            $(this).removeData('pristine');
                            $(this).removeData('originalValue');
                        });
                        $partAlertModal.data('data', item.settings);

                        let $inventorySection = $partAlertModal.find('.inventory-section');
                        let $pricingSection = $partAlertModal.find('.pricing-section');
                        let $inventoryAlternatives = $inventorySection.find('.alternative-checkbox:enabled:checked');
                        let $pricingAlternatives =  $pricingSection.find('.alternative-checkbox:enabled:checked');
                        $inventoryAlternatives.each(function(_index, alt) {
                            $(alt).siblings('.part-wrapper').find('.mpn').addClass('has-existing-alert');
                            $pricingSection.find('.part-list .alternative-checkbox-item:eq(' + $(alt).parent().index() + ') .mpn').addClass('has-existing-alert');
                        });
                        $pricingAlternatives.each(function(_index, alt) {
                            $(alt).siblings('.part-wrapper').find('.mpn').addClass('has-existing-alert');
                            $inventorySection.find('.part-list .alternative-checkbox-item:eq(' + $(alt).parent().index() + ') .mpn').addClass('has-existing-alert');
                        });

                        let existingAlerts = [];
                        $pricingSection.find('.has-existing-alert').each(function(_idx, mpn) {
                            existingAlerts.push($(mpn).text());
                        });
                        if (existingAlerts.length) {
                            $('.existing-alert-warning .existing-alerts').text(existingAlerts.join(', '));
                            $('.existing-alert-warning').removeClass('hide');
                        }
                    }
                },
                error: function(res) {
                    let data = JSON.parse(res.responseText);
                    let message = data.message || utils.translate('something.went.wrong');
                    if ($('.j-registration-tab').length) {
                        if (res.status == 422) {
                            $('.j-registration-tab').addClass('hide');
                            $('.j-error-tab').removeClass('hide');
                            refreshPageTimeout = setTimeout(function() {
                                location.reload();
                            }, 5000);
                        } else {
                            generateToken();
                            $('.j-registration-error').text(message).removeClass('hide');
                        }
                    } else if (!$('.j-preferred-distributor-tab').hasClass('hide')){
                        if (res.status == 422) {
                            message = '<span>Looks like you\'ve reached your alert limit!  Please delete some alerts or <a href="/contact">contact us</a> if you need help</span>';
                            $('.j-distributor-error').html(message).removeClass('hide');
                        } else {
                            $('.j-distributor-error').text(message).removeClass('hide');
                        }
                    } else {
                        $('.j-part-alert-form-error').text(data.message || utils.translate('something.went.wrong')).removeClass('hide');
                    }
                }
            }).always(function() {
                $partAlertModal.find('.loading').hide();
            });
        });

        $partAlertModal.on('modal-closes', function() {
            if (refreshPageTimeout) {
                location.reload();
                clearTimeout(refreshPageTimeout);
            }
            if (closeModalTimeout) {
                clearTimeout(closeModalTimeout);
            }
            if ($('.j-registration-tab').length ) {
                $('#email-address').val('');
                $('#password').val('');
                $('.j-confirm-privacy').prop('checked', false);
                if (!$('.j-registration-tab').hasClass('hide')) {
                    clickRegisterLink();
                    hideRegistration();
                }
            }
            $('.j-success-tab').addClass('hide');
            hidePreferredDistributors();
            $('.j-distributor-error').addClass('hide');
            $('.j-part-alert-form-error').addClass('hide');
            $('.j-registration-error').addClass('hide');
            $partAlertModal.find('.error').removeClass('error');
            if ($partAlertModal.data('data')) {
                buildAlertEditModal($partAlertModal, {
                    settings: $partAlertModal.data('data')
                });
            } else {
                resetAlertModal($partAlertModal);
            }
            if (!$partAlertModal.find('.manufacturer-section').hasClass('hide')) {
                $partAlertModal.find('.alert-manufacturers-select-holder select').val('Select Manufacturer').trigger('change');
                $partAlertModal.find('input.j-manufacturer').val('');
                $partAlertModal.find('span.j-manufacturer').text('');
            }
            step = 1;
        });

        let $pass = $('.password-field');
        let $passwordTooltip = $('#passwordTooltip');
        $pass.on('focus', function() {
            if ($('.j-part-alert-form').attr('action') === '/account/alertRegistration') {
                $passwordTooltip.show();
            }
        });

        $pass.on('focusout', function() {
            if ($('.j-part-alert-form').attr('action') === '/account/alertRegistration') {
                $passwordTooltip.hide();
            }
        });

        $pass.on('keyup', function () {
            if ($('.j-part-alert-form').attr('action') === '/account/alertRegistration') {
                utils.checkPasswordTooltip($pass);
            }
        });

        $partAlertModal.find('.select-all-alt-btn').on('click', function() {
            let $this = $(this);
            let $checkboxes = $this.siblings('.part-list').find('.alternative-checkbox');
            if ($this.attr('data-select') === 'true') {
                $checkboxes.prop('checked', true);
                $this.attr('data-select', 'false').text('Deselect All');
            } else {
                $checkboxes.prop('checked', false);
                $this.attr('data-select', 'true').text('Select All');
            }
        });

        $partAlertModal.on('change', '.alternative-checkbox', function() {
            let $parent = $(this).parents('.part-list');
            if ($parent.find('.alternative-checkbox:checked').length ===  $parent.find('.alternative-checkbox').length) {
                $parent.siblings('.select-all-alt-btn').attr('data-select', false).text('Deselect All');
            } else {
                $parent.siblings('.select-all-alt-btn').attr('data-select', true).text('Select All');
            }
        });

        $partAlertModal.find('.alternative-toggle').on('change', function() {
            let $this = $(this);
            let $partList = $this.siblings('.part-list');
            let $selectAll = $this.siblings('.select-all-alt-btn');
            let $existingAltWarning = $this.siblings('.existing-alert-warning');
            if ($this.is(':checked')) {
                $partList.removeClass('is-disabled');
                $partList.find('input').prop('disabled', false);
                $selectAll.removeClass('is-disabled').prop('disabled', false);
                $partList.find('.has-existing-alert').removeClass('is-disabled');
                $existingAltWarning.removeClass('is-disabled');
            } else {
                $partList.addClass('is-disabled');
                $partList.find('input').prop('disabled', true);
                $selectAll.addClass('is-disabled').prop('disabled', true);
                $partList.find('.has-existing-alert').addClass('is-disabled');
                $existingAltWarning.addClass('is-disabled');
            }
        });
    });
}

function displayAlertData($row) {
    let item = JSON.parse(decodeURIComponent($row.attr('data-alert')));
    $row.find('.j-data-settings').empty();
    $row.find('.j-data-int-sent').empty();
    let inventoryText = '';
    let pricingText = '';
    let pricingExpires = '';
    let inventoryDate = null;
    let pricingDate = null;
    let hasExpired = false;
    $.each(item.settings, function(_index, obj) {
        switch(obj.type) {
            case 'inventory':
                inventoryText += inventoryText ? ' & ' + obj.comparison_operator + ' ' + parseInt(obj.qty).toLocaleString('en-us') + ' ' + utils.translate('qty') : utils.translate('inventory.alerts') + ': ' + obj.comparison_operator + ' ' + parseInt(obj.qty).toLocaleString('en-us') + ' ' + utils.translate('qty');
                inventoryDate = obj.last_sent && (!inventoryDate || inventoryDate < new Date(obj.last_sent * 1000)) ? new Date(obj.last_sent * 1000) : inventoryDate;
                break;
            case 'pricing': {
                pricingDate = obj.last_sent && (!pricingDate || pricingDate < new Date(obj.last_sent * 1000)) ? new Date(obj.last_sent * 1000) : pricingDate;
                pricingText += pricingText ? ' & ' + obj.comparison_operator + ' ' + utils.translate('to.at.least') + ' $' + utils.toFixed(obj.price, 2) + ' ' + utils.translate('for') + ' ' +  parseInt(obj.qty).toLocaleString('en-us') + ' ' + utils.translate('qty') : utils.translate('pricing.alerts') + ': ' + obj.comparison_operator + ' ' + utils.translate('to.at.least') + ' $' + utils.toFixed(obj.price, 2) + ' ' + utils.translate('for') + ' ' +  parseInt(obj.qty).toLocaleString('en-us') + ' ' + utils.translate('qty');
                let expires = new Date(obj.expireOn * 1000);
                if (expires <= new Date()) {
                    hasExpired = true;
                    pricingExpires += pricingExpires ? ' & ' + utils.translate('expired') + ' ' + utils.formatDatetime(expires) : utils.translate('expired') + ' ' + utils.formatDatetime(expires);
                } else {
                    pricingExpires += pricingExpires ? ' & ' + utils.translate('expires') + ' ' + utils.formatDatetime(expires) : utils.translate('expires') + ' ' + utils.formatDatetime(expires);
                }
                break;
            }
        }
    });
    if (inventoryText) {
        let $text = $('<div class="text"></div>').text(inventoryText);
        $row.find('.j-data-settings').append($text);
    }
    if (pricingText) {
        let $text = $('<div class="text"></div>').text(pricingText);
        $row.find('.j-data-settings').append($text);
        let $expireText = $('<div class="expired-text' + (hasExpired ? ' gray' : '') + '"></div>').text(pricingExpires);
        $row.find('.j-data-settings').append($expireText);
    }
    if (item.original_part) {
        let $text = $('<div class="alternative-text gray"></div>').text(utils.translate('alternate.alert.for.part').replace('%s', item.original_part));
        $row.find('.j-data-settings').append($text);
    }
    if (inventoryDate) {
        $row.find('.j-data-int-sent').append('<div ' + (pricingText ? 'class="inventory-date"' : '') + '>' + utils.formatDatetime(inventoryDate) + '</div>');
    }
    if (pricingDate) {
        $row.find('.j-data-int-sent').append('<div ' + (inventoryText ? 'class="pricing-date"' : '') + '>' + utils.formatDatetime(pricingDate) + '</div>');
    }

    return {
        inventoryText: inventoryText,
        pricingText: pricingText,
        inventoryDate: inventoryDate,
        pricingDate: pricingDate,
        hasExpired: hasExpired,
        pricingExpires: pricingExpires
    };
}


export function buildAlertEditModal($partAlertModal, data) {
    resetAlertModal($partAlertModal);
    $partAlertModal.find('.j-alert-limit-error').addClass('hide');
    if (data.part) {
        $partAlertModal.find('span.j-part-number').text(data.part);
        $partAlertModal.find('input.j-part-number').val(data.part);
    }
    if (data.manufacturer) {
        $partAlertModal.find('input.j-manufacturer').val(data.manufacturer);
        let $manufacturerField = $partAlertModal.find('span.j-manufacturer');
        $manufacturerField.text($manufacturerField.data('by') + ' ' + data.manufacturer);
    }
    if (data.category) {
        $partAlertModal.find('input.j-category').val(data.category);
    }
    let settings = data.settings;
    let inventoryTypes = [];
    let pricingTypes = [];
    $partAlertModal.find('.j-alert-checkbox').prop('checked', false).change();
    $partAlertModal.find('.pricing-alert-expiration').addClass('hide');
    $.each(settings, function(_index, item) {
        let $checkbox = $partAlertModal.find('.j-alert-checkbox[name=' + item.type.toLowerCase() + ']');
        let $section = $('.j-part-alert-tab');
        switch(item.type.toLowerCase()) {
            case 'inventory':
                inventoryTypes.push(item);
                $checkbox.prop('checked', true).change();
                if (inventoryTypes.length == 1) {
                    $section.find('.j-inventory-alert-select').val(item.comparison_operator.toLowerCase()).change();
                    $section.find('input[name=inventoryQty]').val(item.qty);
                } else {
                    let above = inventoryTypes[0].comparison_operator == 'above' ? inventoryTypes[0] : inventoryTypes[1];
                    $($section.find('.j-inventory-alert-select')[0]).val('above').trigger('change');
                    $section.find('input[name=inventoryQty]').val(above.qty);
                    $section.find('.add-inventory-alert:not(.hide)').trigger('click');
                    let below = inventoryTypes[0].comparison_operator == 'below' ? inventoryTypes[0] : inventoryTypes[1];
                    $($section.find('.j-inventory-alert-select')[1]).val('below').trigger('change');
                    $section.find('input[name=inventoryQty2]').val(below.qty);
                }
                break;
            case 'pricing': {
                pricingTypes.push(item);
                $checkbox.prop('checked', true).change();
                let $firstBlock = $($section.find('select[name=pricingAlert]').parents('li')[0]);
                let currentTime = Date.now();
                if (pricingTypes.length == 1) {
                    $section.find('select[name=pricingAlert]').val(item.comparison_operator.toLowerCase()).trigger('change');
                    $section.find('input[name=pricingPrice]').val(item.price);
                    $section.find('input[name=pricingQty]').val(item.qty);
                    $section.find('select[name=pricingExpire]').val(item.expireDuration).trigger('change');
                    if (item.expireOn) {
                        $firstBlock.find('.expire-on-date').text(utils.formatDate(new Date(item.expireOn*1000)));
                        $firstBlock.find('.pricing-alert-expiration .date').text(utils.formatDatetime(new Date(item.expireOn*1000)));
                        $firstBlock.find('.pricing-alert-expiration').removeClass('hide');
                        if (currentTime > item.expireOn*1000) {
                            $firstBlock.find('.expired-notice').removeClass('hide');
                        }
                    }
                } else {
                    let decrease = pricingTypes[0].comparison_operator.toLowerCase() == 'decrease' ? pricingTypes[0] : pricingTypes[1];
                    $section.find('select[name=pricingAlert]').val(decrease.comparison_operator.toLowerCase()).trigger('change');
                    $section.find('input[name=pricingPrice]').val(decrease.price);
                    $section.find('input[name=pricingQty]').val(decrease.qty);
                    $section.find('select[name=pricingExpire]').val(decrease.expireDuration).trigger('change');
                    if (decrease.expireOn) {
                        $firstBlock.find('.expire-on-date').text(utils.formatDate(new Date(decrease.expireOn*1000)));
                        $firstBlock.find('.pricing-alert-expiration .date').text(utils.formatDatetime(new Date(decrease.expireOn*1000)));
                        $firstBlock.find('.pricing-alert-expiration').removeClass('hide');
                        if (currentTime > decrease.expireOn*1000) {
                            $firstBlock.find('.expired-notice').removeClass('hide');
                        }
                    }

                    $section.find('.add-pricing-alert:not(.hide)').trigger('click');
                    let increase = pricingTypes[0].comparison_operator == 'increase' ? pricingTypes[0] : pricingTypes[1];
                    let $secondBlock = $($section.find('select[name=pricingAlert2]').parents('li')[0]);
                    $section.find('select[name=pricingAlert2]').val(increase.comparison_operator.toLowerCase()).trigger('change');
                    $section.find('input[name=pricingPrice2]').val(increase.price);
                    $section.find('input[name=pricingQty2]').val(increase.qty);
                    $section.find('select[name=pricingExpire2]').val(increase.expireDuration).trigger('change');
                    if (increase.expireOn) {
                        $secondBlock.find('.expire-on-date').text(utils.formatDate(new Date(increase.expireOn*1000)));
                        $secondBlock.find('.pricing-alert-expiration .date').text(utils.formatDatetime(new Date(increase.expireOn*1000)));
                        $secondBlock.find('.pricing-alert-expiration').removeClass('hide');
                        if (currentTime > increase.expireOn*1000) {
                            $secondBlock.find('.expired-notice').removeClass('hide');
                        }
                    }
                }
                break;
            }
        }
    });
    $partAlertModal.data('data', settings);

    if (!$partAlertModal.find('.j-pricing-checkbox:checked').length) {
        if ($partAlertModal.find('.j-pricing-alert').attr('data-have-price') != 'true') {
            $partAlertModal.find('.no-price-warning').removeClass('hide');
            $partAlertModal.find('.pricing-section').addClass('is-disabled');
        } else {
            $partAlertModal.find('.no-price-warning').addClass('hide');
            $partAlertModal.find('.pricing-section').removeClass('is-disabled');
        }
    }

    if (data.default) {
        let defaultSettings = [{
            type: 'inventory',
            comparison_operator: 'above'
        }];
        $partAlertModal.find('.j-alert-checkbox[name=inventory]').trigger('click');
        $partAlertModal.data('data', defaultSettings);
    }

    if (data.distributors) {
        let distributors = data.distributors;
        distributors = distributors ? distributors.split(',') : [];
        $('.j-preferred-distributor-tab ').find('input[type=checkbox]').each(function() {
            if (distributors.indexOf($(this).val()) !== -1) {
                $(this).prop('checked', true);
            } else {
                $(this).prop('checked', false);
            }
            $(this).removeData('pristine');
            $(this).removeData('originalValue');
        });
    }
}

export function resetAlertModal($partAlertModal) {
    $partAlertModal.find('.pricing-section').removeClass('is-disabled');
    $partAlertModal.find('.j-alert-checkbox').prop('checked', true).change();
    $partAlertModal.find('.remove-alert').click();

    $partAlertModal.find('select[name=inventoryAlert]').val('above').change();
    $partAlertModal.find('input[name=inventoryQty]').val('');

    $partAlertModal.find('select[name=pricingAlert]').val('decrease').change();
    $partAlertModal.find('input[name=pricingQty]').val('');
    $partAlertModal.find('input[name=pricingPrice]').val('');
    $partAlertModal.find('select[name=pricingExpire]').val(2).change();
    $partAlertModal.find('.expired-notice').addClass('hide');
    $partAlertModal.find('.no-price-warning').addClass('hide');

    $partAlertModal.find('.alternative-toggle').prop('checked', false).change();
    $partAlertModal.find('.select-all-alt-btn[data-select="true"]').click();
}

export function getPartAlertAlternatives(part, manufacturer, includeAlerts) {
    $('.part-alert-alternates').addClass('hide');
    $.ajax({
        url: '/api/alternatives?part=' + encodeURIComponent(part) + '&manufacturer=' + encodeURIComponent(manufacturer) + (includeAlerts ? '&getUserAlerts=true' : ''),
        method: 'get',
        success: function(data) {
            if (data.data.length) {
                populateAlternatives(data.data);
            }
        }
    });
}

export function populateAlternatives(data) {
    $('.part-alert-alternates .part-list').empty();
    let $inventoryList = $('.inventory-section .part-alert-alternates .part-list');
    let $pricingList = $('.pricing-section .part-alert-alternates .part-list');
    let $table = $('.alert-page-table');
    let existingAlerts =[];
    for (let item of data.slice(0, 10)) {
        let exists = item.exists;
        if ($table.length) {
            let $rows = $table.find('.j-data-part-number[data-part-number="' + item['Manufacturer Part Number'].toUpperCase() + '"]');
            $rows.each(function(_index, partData) {
                if ($(partData).find('.manufacturer-text').text().toUpperCase() === item['Manufacturer'].toUpperCase()) {
                    exists = true;
                }
            });
        }
        $inventoryList.append('<div class="alternative-checkbox-item"><input checked type="checkbox" class="alternative-checkbox" name="alt_inventory_' + item['Manufacturer Part Number'] + '|' + item['Manufacturer'] + '" disabled><div class="part-wrapper"><div class="mpn' + (exists ? ' has-existing-alert is-disabled' : '') + '">' + item['Manufacturer Part Number'] + '</div><div class="manufacturer">' + item['Manufacturer'] + '</div></div></div>');
        $pricingList.append('<div class="alternative-checkbox-item"><input checked type="checkbox" class="alternative-checkbox" name="alt_pricing_' + item['Manufacturer Part Number'] + '|' + item['Manufacturer'] + '" disabled><div class="part-wrapper"><div class="mpn' + (exists ? ' has-existing-alert is-disabled' : '') + '">' + item['Manufacturer Part Number'] + '</div><div class="manufacturer">' + item['Manufacturer'] + '</div></div></div>');
        if (exists) {
            existingAlerts.push(item['Manufacturer Part Number']);
        }
    }

    if (existingAlerts.length) {
        $('.existing-alert-warning .existing-alerts').text(existingAlerts.join(', '));
        $('.existing-alert-warning').removeClass('hide');
    }

    $('.part-alert-alternates').removeClass('hide');
}

export function getDistributors() {
    let $partAlertModal = $('#partAlertModal');
    
    $.ajax({
        url: '/ajax/getDistributors?partNumber=' + encodeURIComponent($partAlertModal.find('input[name=partNumber]').val()) + '&manufacturer=' + encodeURIComponent($partAlertModal.find('input[name=manufacturer]').val()),
        dataType: 'html',
        timeout: 15000,
        success: function (html) {
            $partAlertModal.find('.j-prerrered-content').append(html);
            initPopupContent();
        },
        error: function () {
            $partAlertModal.find('.j-prerrered-content').append('<div class="alert alert-danger is-small">' + utils.translate('something.went.wrong') + '</div>');
        }
    });

    function initPopupContent() {
        $.each($('.preferred-distributors-list-holder'), function (index, item) {
            list[index] = new distributorList($(item));
        });
    
        $partAlertModal.on('modal-closes', function() {
            $('.j-preferred-distributor-tab').find('input[type=checkbox]').each(function() {
                if ($(this).data('pristine') === false) {
                    $(this).prop('checked', $(this).data('originalValue'));
                }
            });
        });
    
        $('.j-preferred-distributor-tab').find('input[type=checkbox]').on('change', function() {
            if (typeof $(this).data('originalValue') === 'undefined') {
                $(this).data('pristine', false);
                $(this).data('originalValue', !$(this).prop('checked'));
            }
        });
    }

    function distributorList($el) {
        this.$el = $el;

        this.toggle = function($c, p) {
            if (($c.data('pristine') !== false)) {
                $c.data('originalValue', $c.prop('checked'));
            }
            $c.prop('checked', p);
            $c.data('pristine', false);
        };

        this.initialize = function () {
            let that = this;

            this.$el.find('.j-select-all').click(function (e) {
                e.preventDefault();
                that.$el.find('input[type=checkbox]').each(function() {
                    that.toggle($(this), true);
                });
            });

            this.$el.find('.j-deselect-all').click(function (e) {
                e.preventDefault();
                that.$el.find('input[type=checkbox]').each(function() {
                    that.toggle($(this), false);
                });
            });
        };

        this.getChecked = function () {
            return this.$el.find('input:checked');
        };

        this.initialize();
    }
}

export function checkSelected() {
    let checked = [];
    for (let i in list) {
        $.each(list[i].getChecked(), function (_index, item) {
            checked.push(parseInt($(item).val(), 10));
        });
    }
    return checked.length;
}